import * as userActions from './actions';

import { AjaxError } from 'rxjs/ajax';
import { catchError, filter, map, mapTo, switchMap, withLatestFrom, mergeMap } from 'rxjs/operators';
import qs from 'qs';

import { Epic } from 'redux-observable';
import { RootAction } from 'store/actions';
import { RootDependencies } from 'store/dependencies';
import { RootState } from 'store/reducer';
import { UnauthorizedError } from 'store/user/errors';
import { isActionOf } from 'typesafe-actions';
import { of } from 'rxjs';
import { replace } from 'connected-react-router';
import { getErrorCode } from 'store/utils';
import { ERR_DEFAULT } from 'utils/constants';

const UNAUTHORIZED_ERROR_CODE = 401;
const NOT_FOUND_ERROR_CODE = 404;
const BAD_REQUEST_ERROR_CODE = 400;
const INTERNAL_SERVER_ERROR_CODE = 500;
const errors = [UNAUTHORIZED_ERROR_CODE, NOT_FOUND_ERROR_CODE, BAD_REQUEST_ERROR_CODE, INTERNAL_SERVER_ERROR_CODE];

export const getCurrentUser: Epic<RootAction, RootAction, RootState, RootDependencies> = (
  action$,
  state$,
  { apiClient },
) =>
  action$.pipe(
    filter(isActionOf(userActions.getCurrentUser.request)),
    withLatestFrom(state$),
    switchMap(([, state]) =>
      apiClient(state)
        .getCurrentUser()
        .pipe(
          map(({ response: user }) => {
            return userActions.getCurrentUser.success(user);
          }),
          catchError((error: Error) => {
            if (error instanceof AjaxError && errors.includes(error.status)) {
              return of(userActions.getCurrentUser.failure({ error: new UnauthorizedError(), errorCode: ERR_DEFAULT }));
            }

            return of(userActions.getCurrentUser.failure({ error, errorCode: getErrorCode(error) }));
          }),
        ),
    ),
  );

export const getCurrentUserRedirect: Epic<RootAction, RootAction, RootState> = (action$, state$) =>
  action$.pipe(
    filter(isActionOf(userActions.getCurrentUser.success)),
    withLatestFrom(state$),
    mergeMap(([, state]) => {
      const search: string = state.router?.location?.search ?? '';
      // eslint-disable-next-line @typescript-eslint/no-unused-vars
      const { authToken, apiUrl, buildingUuid, ...restSearch } = qs.parse(search, { ignoreQueryPrefix: true });

      const newSearchString = qs.stringify(restSearch);
      const path = state.router?.location?.pathname ?? '/';
      return of(replace(newSearchString ? `${path}?${newSearchString}` : path));
    }),
  );

export const getCurrentUserFailureRedirect: Epic<RootAction, RootAction, RootState> = action$ =>
  action$.pipe(filter(isActionOf(userActions.getCurrentUser.failure)), mapTo(replace('/')));
